import React from 'react'
import styles from './Style.module.css'

const Placeholder = ({
    heading,
    para,
    icon,
    customClass
}) => {
  return (
    <div className={`${styles.Placeholder} ${customClass}`}>
        <div className={styles.icon}>
            {icon}
        </div>
        <div className={styles.content}>
            <h6>{heading}</h6>
            <p>{para}</p>
        </div>
    </div>
  )
}

export default Placeholder